import { SOLUTIONS } from 'context/solutions/constants';
import { ConnectIcon, AnalyticsIcon, StorageIcon } from 'components/icons';

export const AFEX_SOLUTIONS = [
  {
    title: ['Access &', 'Retention'],
    icon: ConnectIcon,
    id: `accessAndRetention interactive`,
    url: SOLUTIONS.ACCESS_AND_RETENTION.LINK,
    description: `
      With smallholder farmers at the center, we unlock a 
      world of value-adding services that improve farmer 
      livelihoods and make our partners their partners
    `,
  },
  {
    title: ['Big Data &', 'Analytics'],
    icon: AnalyticsIcon,
    id: `bigDataAnalytics interactive`,
    url: SOLUTIONS.BIG_DATA_ANALYTICS.LINK,
    description: `
      With technology driving our operations, we unlock 
      a world of convenience in trading commodities, 
      while creating systems for capturing and 
      analyzing valuable data
    `,
  },
  {
    title: [],
    id: `solutionImage`,
    url: `/`,
    description: ``,
  },
  {
    title: ['Efficient', 'Markets'],
    icon: StorageIcon,
    id: 'efficientMarkets interactive',
    url: SOLUTIONS.EFFICIENT_MARKETS.LINK,
    description: `
      With our infrastructure being utilized as a trusted platform
      for all players, we unlock a world of efficiency and transparency, 
      enabling the growth of disruptive, scalable financing structures 
      for Nigerian Agriculture
    `,
  },
];
